function getDoorDistanceFromRight(action) {
	return action.unit.size[0] - action.doorPosition - .5 * action.doorWidth;
}
export { getDoorDistanceFromRight };

//# sourceMappingURL=index132.js.map